import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import { Images } from "@constants/images";
import {Subscription} from "rxjs";
import {NotificationFacade} from "@redux/facades/notification.facade";
import {LanguageFacade} from "@redux/facades/language.facade";
import {AuthService} from "@services/auth/auth.service";
import {Router} from "@angular/router";

@Component({
  standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() search: boolean = false;
  public lang: string = 'es';
  public mobile = false;
  public background: string | null = null;
  public images = Images
  public unsubscribeLanguage: Subscription;

  constructor(
    public languageFacade: LanguageFacade,
    public authService: AuthService,
    private router: Router,
  ) {
    if (window.innerWidth < 577) {
      this.mobile = true;
    }
    this.unsubscribeLanguage = this.languageFacade.languageState$.subscribe(
      ok => {
        this.lang = ok.selected;
      }
    );
  }

  ngOnInit(): any {
    if (this.lang === 'en') {
      if (!this.search)
        this.background = !this.mobile ? this.images.header1_en : this.images.header1_en_m;
      else
        this.background = !this.mobile ? this.images.header2_en : this.images.header2_en_m;
    } else if (this.lang === 'es') {
      if (!this.search)
        this.background = !this.mobile ? this.images.header1_es : this.images.header1_es_m;
      else
        this.background = !this.mobile ? this.images.header2_es : this.images.header2_es_m;
    }
  }

  // tslint:disable-next-line:typedef
  ngOnDestroy() {
    const self = this;
    self.unsubscribeLanguage.unsubscribe();
  }

  public logout = () => {
    this.authService.logout();
    this.router.navigate(['/auth']);
  }
}
